<template>
  <div>
    <a-modal v-model="visible" :width="960" title="选择缺陷" @ok="handleOk" @cancel="onCancel">
      <a-input-search v-model="searchKeyword" placeholder="ID或标题搜索" class="requirement_search" allow-clear enter-button @search="onSearch" />
      <a-table :loading="loading" :expand-icon-column-index="2" :pagination="pagination" size="small" :columns="columns" row-key="id" :row-selection="rowSelection" :data-source="issueData" @change="handleTableChange">
        <span slot="customId" slot-scope="text, record"> {{ record.key }}</span>
        <span slot="customTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="issue_title" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="issueStatus[record.status].status" :text="issueStatus[record.status].label" />
        </span>
      </a-table>
    </a-modal>
    <a v-tc="{ name: '关联缺陷' }" class="case-requirement-relation" @click="onSelect">
      <a-icon type="search" />
      关联缺陷
    </a>
  </div>
</template>

<script>
import { issueList } from '@/api/project/issue';
import { issueStatus } from '@/utils/dictionary';

const columns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  }
];
const selectedColumns = [
  {
    title: 'ID',
    width: 100,
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '状态',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    bugList: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      issueStatus,
      selectedColumns,
      loading: false,
      visible: false,
      issues: {},
      issueData: [],
      selected: [],
      selectedRowKeys: [],
      searchKeyword: '',
      issueIds: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      releaseId: parseInt(this.$route.query.releaseId) || null,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: { project_id: record.project.id || this.projectId },
          query: { issueId: record.id }
        }).href;
      };
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      }
    },
    selected() {
      // this.$emit('change', this.selected);
      this.selectedRowKeys = [...this.selected];
    },
    bugList() {
      this.issues = this.bugList;
    }
  },
  methods: {
    getIssueList() {
      this.loading = true;
      issueList({
        project_id: this.projectId,
        title: this.searchKeyword,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.issueData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getIssueList();
    },

    onSearch() {
      this.utils.trackClick({ name: '搜索缺陷' });
      this.pagination.current = 1;
      this.getIssueList();
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      selectedRows.forEach(item => {
        this.$set(this.issues, item.id, { id: item.id, key: item.key, title: item.title, status: item.status });
      });
    },

    onSelect() {
      this.visible = true;
      this.selectedRowKeys = [...this.selected];
      this.getIssueList();
    },

    handleOk() {
      this.utils.trackClick({ name: '提交关联缺陷' });
      this.selected = [...this.selectedRowKeys];
      this.close();
      this.$emit('bind-issues', this.selected);
    },

    onCancel() {
      this.utils.trackClick({ name: '取消关联缺陷' });
      this.close();
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:issue:detail',
        query: { issueId: record.id }
      });
    },

    close() {
      this.visible = false;
      this.selectedRowKeys = [];
    }
  }
};
</script>
<style lang="less" scoped>
.search-button {
  width: 100%;
}

.issue_title:hover {
  cursor: pointer;
  color: #1890ff;
}

.issue_title {
  color: rgba(0, 0, 0, 0.65);
}

.requirement_search {
  margin: 8px 0;
}

.case-requirement-relation {
  line-height: 32px;
}
</style>
